export default "__VITE_ASSET__g7mY0K8g__"